import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Cell, PieChart, Pie, Sector } from 'recharts'
import './index.css'

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'


const useStyles = makeStyles(theme => ({
  heading: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  center: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}))

const ActiveSectorMark = ({ cx = 0, cy = 0, innerRadius = 0, outerRadius = 0, startAngle = 0, endAngle = 0, activeFill = '#fff' }) => {
  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={activeFill} />
    </g>
  );
};

const Gauge = ({ max, value, name, width, height, color, icon, difference = 0 }) => {
  const theme = useTheme()
  const classes = useStyles()

  const Icon = icon

  // Default measurements
  width = width || 100
  height = height || 100

  // Default min
  const min = 0

  // Figure out the gauge percentage, how close it is to it's "max allowed"
  const percentage = ((Math.min(Math.max(value, min), max) - min) / (max - min)) * 100

  const data = [
    { value: percentage },
    { value: 100 - percentage }
  ];

  return (
    <Box>
      <Box textAlign="center" position="relative">
        <Box height={width / 2} mb={5}>
          <PieChart width={width} height={height}>
            <Pie
              isAnimationActive={false}
              activeIndex={0}
              activeShape={<ActiveSectorMark activeFill={color} />}
              data={data}
              dataKey='value'
              innerRadius="80%"
              outerRadius="100%"
              startAngle={180}
              endAngle={0}
              cy={width / 2}
              cx={(width / 2) - 5}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} strokeWidth={0} fill={theme.palette.background.light} />
              ))}
            </Pie>
          </PieChart>

          <Box className={classes.center} width={80} height={80}>
            <Icon width={80} height={80} />
          </Box>
        </Box>
        <Box color={color} mb={2}>
          <Typography variant="subtitle1" className={classes.heading}>{name}</Typography>
        </Box>
      </Box>
      <Box textAlign="center">
        <Typography variant="h5">{value}%</Typography>

        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
          <Box>
            {difference > 0
              ? <ArrowUpwardIcon />
              : (difference < 0)
                ? <ArrowDownwardIcon />
                : '-'}
          </Box>
          <Typography variant="body2" color="textSecondary">
            {difference > 0
              ? `${Math.abs(difference)}% increase`
              : (difference < 0)
                ? `${Math.abs(difference)}% decrease`
                : ''}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

Gauge.propTypes = {
  value: PropTypes.number.isRequired
}

export default Gauge;
